import { Dithering } from '@paper-design/shaders-react';
import { DITHER_BACKGROUND } from '@/frontend/lib/ditherBackground';

// Paper Shaders throws "WebGL is not supported" from an async init, so a React
// error boundary can't catch it. Probe synchronously and skip the shader when
// WebGL2 is unavailable — the auth pages render fine without the background.
let webgl2Supported: boolean | null = null;
function supportsWebGL2(): boolean {
  if (webgl2Supported === null) {
    try {
      webgl2Supported = !!document.createElement('canvas').getContext('webgl2');
    } catch {
      webgl2Supported = false;
    }
  }
  return webgl2Supported;
}

// Animated dither background for the auth screens (login, signup, password reset).
// Server-rendered pages (landing, waitlist) get the same visual via the
// dither_background.ts entrypoint — both read DITHER_BACKGROUND.
export function DitherBackground() {
  if (typeof document === 'undefined' || !supportsWebGL2()) return null;

  return (
    <Dithering
      {...DITHER_BACKGROUND}
      className="absolute inset-0 w-full h-full"
      style={{ zIndex: 0, opacity: 0.6 }}
    />
  );
}
